export default __webpack_public_path__ + "static/media/wellness-person.9dc648f8.png";